"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/addressViewModel',["require", "exports", "knockout", "moment", "services/changeHistoryService"], function (require, exports, ko, moment, changeHistoryService) {
    "use strict";

    var AddressViewModel = function () {
        function AddressViewModel(address) {
            _classCallCheck(this, AddressViewModel);

            this.moment = moment;
            this.originalAddress = null;
            this.addressLine1 = ko.observable('');
            this.addressLine2 = ko.observable('');
            this.addressLine3 = ko.observable('');
            this.addressLine4 = ko.observable('');
            this.postCode = ko.observable('');
            this.type = ko.observable('');
            this.isActive = ko.observable(false);
            this.created = ko.observable('');
            this.creator = ko.observable('');
            this.modified = ko.observable('');
            this.modifier = ko.observable('');
            this.addressHistory = ko.observableArray([]);
            this.addressLine1ValidationEnabled = ko.observable(false);
            this.addressLine2ValidationEnabled = ko.observable(false);
            this.addressLine3ValidationEnabled = ko.observable(false);
            this.addressLine4ValidationEnabled = ko.observable(false);
            this.postCodeValidationEnabled = ko.observable(false);
            this.isActiveValidationEnabled = ko.observable(false);
            if (address) {
                this.originalAddress = address;
                this.setProperties(address);
            }
            this.setValidationRules();
            this.setupValidationSubscriptions();
        }

        _createClass(AddressViewModel, [{
            key: "getHistory",
            value: function getHistory() {
                changeHistoryService.getAddressHistory(this.id).done(function (addressHistory) {
                    this.addressHistory(addressHistory);
                }.bind(this));
            }
        }, {
            key: "resetValues",
            value: function resetValues() {
                this.setProperties(this.originalAddress);
                this.addressLine1ValidationEnabled(false);
                this.addressLine2ValidationEnabled(false);
                this.addressLine3ValidationEnabled(false);
                this.addressLine4ValidationEnabled(false);
                this.postCodeValidationEnabled(false);
                this.isActiveValidationEnabled(false);
            }
        }, {
            key: "validate",
            value: function validate() {
                this.addressLine1ValidationEnabled(true);
                this.addressLine2ValidationEnabled(true);
                this.addressLine3ValidationEnabled(true);
                this.addressLine4ValidationEnabled(true);
                this.postCodeValidationEnabled(true);
                this.isActiveValidationEnabled(true);
                return this.isValid();
            }
        }, {
            key: "setProperties",
            value: function setProperties(address) {
                this.id = address.id;
                this.addressLine1(address.addressLine1);
                this.addressLine2(address.addressLine2);
                this.addressLine3(address.addressLine3);
                this.addressLine4(address.addressLine4);
                this.postCode(address.postCode);
                this.type(address.type);
                this.isActive(address.isActive);
                this.created(address.created);
                this.creator(address.creator);
                this.modified(address.modified);
                this.modifier(address.modifier);
            }
        }, {
            key: "setValidationRules",
            value: function setValidationRules() {
                this.addressLine1.extend({
                    required: { onlyIf: this.addressLine1ValidationEnabled, message: 'Address Line 1 is a required field' },
                    maxLength: { onlyIf: this.addressLine1ValidationEnabled, params: 35, message: 'Maximum of 35 characters' }
                });
                this.addressLine2.extend({
                    maxLength: { onlyIf: this.addressLine2ValidationEnabled, params: 35, message: 'Maximum of 35 characters' }
                });
                this.addressLine3.extend({
                    required: { onlyIf: this.addressLine3ValidationEnabled, message: 'Address Line 3 is a required field' },
                    maxLength: { onlyIf: this.addressLine3ValidationEnabled, params: 35, message: 'Maximum of 35 characters' }
                });
                this.addressLine4.extend({
                    required: { onlyIf: this.addressLine4ValidationEnabled, message: 'Address Line 4 is a required field' },
                    maxLength: { onlyIf: this.addressLine4ValidationEnabled, params: 35, message: 'Maximum of 35 characters' }
                });
                this.postCode.extend({
                    required: { onlyIf: this.postCodeValidationEnabled, message: 'Post code is a required field' },
                    maxLength: { onlyIf: this.postCodeValidationEnabled, params: 20, message: 'Maximum of 20 characters' }
                });
                this.isValid = ko.validatedObservable(this).isValid;
            }
        }, {
            key: "setupValidationSubscriptions",
            value: function setupValidationSubscriptions() {
                this.addressLine1Subscription = this.addressLine1.subscribe(function () {
                    this.addressLine1ValidationEnabled(false);
                }, this);
                this.addressLine2Subscription = this.addressLine2.subscribe(function () {
                    this.addressLine2ValidationEnabled(false);
                }, this);
                this.addressLine3Subscription = this.addressLine3.subscribe(function () {
                    this.addressLine3ValidationEnabled(false);
                }, this);
                this.addressLine4Subscription = this.addressLine4.subscribe(function () {
                    this.addressLine4ValidationEnabled(false);
                }, this);
                this.postCodeSubscription = this.postCode.subscribe(function () {
                    this.postCodeValidationEnabled(false);
                }, this);
            }
        }, {
            key: "clearValue",
            value: function clearValue(observable) {
                observable('');
            }
        }, {
            key: "clearAllValues",
            value: function clearAllValues() {
                this.addressLine1('');
                this.addressLine2('');
                this.addressLine3('');
                this.addressLine4('');
                this.postCode('');
                this.isActive(false);
            }
        }, {
            key: "dispose",
            value: function dispose() {
                this.addressLine1Subscription.dispose();
                this.addressLine2Subscription.dispose();
                this.addressLine3Subscription.dispose();
                this.addressLine4Subscription.dispose();
                this.postCodeSubscription.dispose();
            }
        }]);

        return AddressViewModel;
    }();

    return AddressViewModel;
});
//# sourceMappingURL=addressViewModel.js.map;
